export const REQUESTS_DISPLAY_FIELDS_URL = 'requests/display-fields';
export const REQUESTS_DISPLAY_FILES_URL = '/requests/display-files';
export const BASIC_INFORMATION_ON_REQUEST_NAME = 'requests.basic.information';
export const RESPONSE_REQUEST_NAME = 'requests.response.information';
export const RESPONSE_REQUEST_ADDITIONAL_PLACEMENT_NAME = 'requests.response.additional.placement.information';
export const RESPONSE_REQUEST_REJECTION_NAME = 'request.generate.refusal.information';
export const PROLONGATION_REQUEST = 'request.prolongation.information';
export const RESPONSE_PROLONGATION = 'response.prolongation.information';
export const REQUESTS_ENTITY_NAME = 'requests';
